import * as t from "io-ts";
import nullable from "./nullable";
import isoDateTimeForJSON from "./isoDateTimeForJSON";
import { cargoTypeT } from "./types";
import { latitudeT, longitudeT } from "./lat-lon";
export const createDriverUpdateCargoTypes = ({ decimal, }) => {
    const locationT = t.strict({
        lat: latitudeT,
        lon: longitudeT,
        accuracy: t.number,
        place: nullable(t.strict({
            address: t.string,
            postcode: t.string,
            city: t.string,
            country: t.string,
            placeName: t.string,
        })),
    });
    const stopT = t.strict({
        placeName: t.string,
        address: nullable(t.string),
        city: nullable(t.string),
        postcode: nullable(t.string),
        country: nullable(t.string),
        position: t.intersection([
            t.strict({
                lon: longitudeT,
                lat: latitudeT,
            }),
            t.partial({
                accuracy: nullable(t.number),
            }),
        ]),
    });
    const updateCargoStopDataT = t.partial({
        type: cargoTypeT,
        description: t.string,
        date: isoDateTimeForJSON,
        time: t.string,
        place: stopT,
        lm: decimal,
        clientId: nullable(t.string),
    });
    const updateCargoStopT = t.strict({
        data: updateCargoStopDataT,
        position: nullable(locationT),
    });
    return { updateCargoStopT, updateCargoStopDataT };
};
//# sourceMappingURL=driver-update-cargo.js.map